import { render, staticRenderFns } from "./Accessibility.vue?vue&type=template&id=0e8af658&scoped=true&"
import script from "./Accessibility.vue?vue&type=script&lang=js&"
export * from "./Accessibility.vue?vue&type=script&lang=js&"
import style0 from "./Accessibility.vue?vue&type=style&index=0&id=0e8af658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8af658",
  null
  
)

export default component.exports